import {
  Icon,
  Flex,
  Text,
  Center,
  Avatar,
  Button,
  Box,
} from '@chakra-ui/react';
import { decode } from 'js-base64';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { NotificationTime } from '../../components/Time';
import { RiEditLine } from 'react-icons/ri';
import {
  ratingOptions,
  getSelectionRatingStyle,
} from '@/constants/scorecard-configs';
import _ from 'lodash';

export const ScoreCardContainer = ({
  notification = {},
  onClose = () => {},
  type,
  icon = RiEditLine,
  iconColor = '#605AFB',
  iconbg = '#F4F4FB',
}) => {
  const [markAsRead] = useMarkAsReadMutation();
  const { custom_attributes } = notification || {};
  const data = JSON.parse(decode(custom_attributes));

  const {
    candidate,
    interviewer,
    scorecard_url,
    job_name,
    interview_name,
    scorecard_rating = {},
  } = data || {};

  const selectedRating = _.find(ratingOptions, {
    value: scorecard_rating,
  });

  const styleProps = getSelectionRatingStyle(selectedRating);
  const label = selectedRating?.label;
  const IconComponent = selectedRating?.icon;

  const fillScorecardText = () => (
    <Flex flexWrap="wrap" gap="2px" w="100%">
      <Text fontSize="sm">Don’t forget to fill the following scorecard!</Text>
    </Flex>
  );

  const reviewScorecardText = () => {
    if (label) {
      return (
        <Flex gap="4px" alignItems="center" flexWrap="wrap">
          <Text fontSize="sm" fontWeight="semibold">
            {interview_name}
          </Text>
          <Text fontSize="sm">feedback submitted:</Text>
          <Text as="span" fontSize="sm" fontWeight="semibold">
            {candidate?.name}
          </Text>
          <Text fontSize="sm">-</Text>
          <Text fontSize="sm" fontWeight="semibold">
            {job_name}
          </Text>
        </Flex>
      );
    }

    return (
      <Flex flexWrap="wrap" gap="2px">
        <Text fontSize="sm">There’s</Text>
        <Text size="sm-semi-bold">1 new scorecard</Text>
        <Text fontSize="sm">to review</Text>
      </Flex>
    );
  };

  const type_text = {
    fill: fillScorecardText,
    review: reviewScorecardText,
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="46px" h="46px" borderRadius="full" bg={iconbg}>
        <Icon as={icon} color={iconColor} />
      </Center>
      <Flex flexDir="column" ml="16px" gap="6px" alignSelf="start" flex={1}>
        {type_text[type] && type_text[type]()}

        <Text size="sm-semi-bold" mt="8px">
          Details
        </Text>

        <Flex
          border="1px solid"
          borderColor="border-color"
          borderRadius="sm"
          p="14px"
          gap="12px"
          flexDir="column"
        >
          <Flex flexDirection="column" gap="2px">
            <Text size="sm-semi-bold">Candidate</Text>
            <Flex gap="3px">
              <Avatar
                name={candidate?.name}
                src={candidate?.avatar}
                borderRadius={'4px'}
                size={'2xs'}
              />
              <Text fontSize="sm">{candidate?.name}</Text>
            </Flex>
          </Flex>
          {type === 'review' && (
            <Flex flexDirection="column" gap="2px">
              <Text size="sm-semi-bold">Reviewer</Text>
              <Flex gap="3px">
                <Avatar
                  name={interviewer?.name}
                  src={interviewer?.avatar}
                  borderRadius={'4px'}
                  size={'2xs'}
                />
                <Text fontSize="sm">{interviewer?.name}</Text>
              </Flex>
            </Flex>
          )}
          {selectedRating && (
            <Box py="2">
              <Text size="sm-semi-bold">Overall evaluation</Text>
              <Flex gap="6px">
                {IconComponent && (
                  <Icon
                    as={IconComponent}
                    h={styleProps?.h || '24px'}
                    w={styleProps?.w || '24px'}
                    color={styleProps?.color}
                  />
                )}
                <Text fontSize="sm">{label}</Text>
              </Flex>
            </Box>
          )}
          <Flex flexDirection="column" gap="2px">
            <Text size="sm-semi-bold">Interview</Text>
            <Text fontSize="sm">{interview_name}</Text>
          </Flex>
          <Flex flexDirection="column" gap="2px">
            <Text size="sm-semi-bold">Job</Text>
            <Text fontSize="sm">{job_name}</Text>
          </Flex>
        </Flex>
        <NotificationTime notification={notification} />
        {scorecard_url && (
          <Button
            w="fit-content"
            variant="ats-primary"
            borderRadius="8px"
            onClick={() => {
              markAsRead();
              window.open(scorecard_url, '_self');
              onClose();
            }}
            maxH="34px"
            data-test-id={
              type === 'fill'
                ? 'fill-scorecard-button'
                : 'review-scorecard-button'
            }
          >
            {type === 'fill' ? 'Fill' : 'Review'} scorecard now
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
